import { Env } from "./Env";

export type SharedConfig = {
  env: Env;
  defaultBucket: string;
  inboundEmailBucket: string;
  outboundEmailBucket: string;
};

const stagingConfig: SharedConfig = {
  env: Env.staging,
  defaultBucket: "zickko-staging.firebasestorage.app",
  inboundEmailBucket: "zickko_staging_inbound_bucket",
  outboundEmailBucket: "zickko_staging_outbound_bucket",
};

const devConfig: SharedConfig = {
  env: Env.dev,
  defaultBucket: "zickko-dev.firebasestorage.app",
  inboundEmailBucket: "zickko_dev_inbound_bucket",
  outboundEmailBucket: "zickko_dev_outbound_bucket",
};

const localConfig: SharedConfig = {
  env: Env.local,
  defaultBucket: stagingConfig.defaultBucket,
  inboundEmailBucket: stagingConfig.inboundEmailBucket,
  outboundEmailBucket: stagingConfig.outboundEmailBucket,
};

export const sharedConfig = {
  devConfig,
  localConfig,
  stagingConfig,
};
